<template>
    <div class="row justify-content-center mt-5 mb-5 adwords-visuals">
        <template v-if="isBuilt">
            <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
            <template v-if="!!missed_accounts.length">
                <div class="col-12">
                    <div v-for="missed_account in missed_accounts" class="missed-accounts my-3">There are no accounts connected for {{missed_account}}. Either connect an account or change the metrics/remove this section in the builder.</div>
                </div>
            </template>
            <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
            </div>
            <div class="col-12 col-md-3">
                <h4 class="section-name my-3 text-uppercase">{{adwordsData.name}}</h4>
            </div>
            <div class="col-12 col-md-9">
                <template v-if="errors">
                    <div class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                </template>
                <template v-else>
                    <div v-for="visual in visuals" class="row justify-content-center">
                        <div class="col">
                            <h4 class="adwords-title">{{visual.headlinePart1}} | {{visual.headlinePart2}}</h4>
                            <div class="adwords-sub-title">
                                <span class="ad-graphic">Ad</span><span class="arrow">{{visual.finalUrl}}</span><span class="number"></span>
                            </div>
                            <p class="adwords-text">
                                {{visual.description1}} {{visual.description2}}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <div class="col-12 col-md-3">
                <h3>ADWORDS VISUALS</h3>
            </div>
            <div class="col-12 col-md-9">
                <div class="row justify-content-center">
                    <div class="col">
                        <h4 class="adwords-title">200 Amsterdam Avenue | Elevated Living On The UWS</h4>
                        <div class="adwords-sub-title">
                            <span class="ad">Ad</span><span class="arrow">www.200amsterdam.com/</span><span class="number">(646)655-5942</span>
                        </div>
                        <p class="adwords-text">
                            Ab Enlightned arrival at Nexus of Lincoln Center and Central Park. Unwind in Style
                            with Expansive Views & Three Full Floors of Smart Amenity Offerings. The Penthouse
                            Residences. Expansive Cityscape Views. Smart Amenity Offerings.
                        </p>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col">
                        <h4 class="adwords-title">200 Amsterdam Avenue | Elevated Living On The UWS</h4>
                        <div class="adwords-sub-title">
                            <span class="ad">Ad</span><span class="arrow">www.200amsterdam.com/</span><span class="number">(646)655-5942</span>
                        </div>
                        <p class="adwords-text">
                            Ab Enlightned arrival at Nexus of Lincoln Center and Central Park. Unwind in Style
                            with Expansive Views & Three Full Floors of Smart Amenity Offerings. The Penthouse
                            Residences. Expansive Cityscape Views. Smart Amenity Offerings.
                        </p>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'hasSkb', 'adwordsData'],
        created() {
            if(this.isBuilt){
                this.num_visuals = this.adwordsData.element_configurations.num_visuals;
                this.fetchServerData();
                this.missed_accounts = this.checkAccounts(this.adwordsData);
            }
        },
        data() {
            return {
                visuals:[],
                num_visuals:null,
                missed_accounts:[],
                errors:false,
                query:'',
                showQueries:    this.$store.state.showQueries,
                reloading:true
            }
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        methods: {
            fetchServerData(){
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.adwordsData.report_id,
                    'element_abbr':this.adwordsData.element_abbreviation,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.adwordsData.element_id,
                    'prefixed_element_id': this.adwordsData.report_element_id,
                    'element_name': this.adwordsData.name,
                    'metrics': this.adwordsData.metrics,
                    'segment': this.adwordsData.segment,
                    'accounts': this.adwordsData.accounts,
                    'num_visuals':this.num_visuals,
                    'client_id':this.adwordsData.client_id,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,

                };

                axios.post('/api/reporting/element', params).then((response) => {
                    this.visuals = response.data.visuals;
                    this.query = response.data.query;
                    this.errors = response.data.errors;
                    this.reloading = false;
                });
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.adwords-visuals{
        font-family: Roboto, 'Helvetica Neue', Helvetica, sans-serif;
        h4.adwords-title{
            color:$google-blue;
            font-size:1.8rem;
        }
        div.adwords-sub-title{
            span{
                color:$google-green;
                font-size:1.6rem;
                &.ad-graphic {
                    background-color: #fff;
                    border-radius: 0.2rem;
                    color: $google-green;
                    display: inline-block;
                    font-size: 1.2rem;
                    border: 0.1rem solid $google-green;
                    padding: 0 0.2rem;
                    line-height: 1.4rem;
                    vertical-align: baseline;
                    margin-right: 0.3rem;
                }
                &.number{
                    color:$google-gray;
                }
                &.arrow{
                    font-size:1.3rem;
                    &::after{
                        border-left: 0.8rem solid transparent;
                        border-right: 0.8rem solid transparent;
                        content: "";
                        display: inline-block;
                        height: 0;
                        width: 0;
                        margin:0 1rem;
                        margin-top:-1rem;
                        border-top: .8rem dashed $google-green;
                    }
                }
            }
        }
        p{
            color:$google-gray;
        }
    }
</style>
